import React, {useEffect, useRef, useState} from "react";
import {
    DetailsPanelDiv,
    DetailsPanelLeftSection,
    DetailsPanelMiddleSection,
    DetailsPanelRightSection,
    SectionForDetailPanelLeft,
    SectionForDetailPanelLeftHeader,
    SectionForDetailPanelRight
} from "../MembersTableStyles";
import {formatDate} from "../../../utils/Utils";
import {ROLES} from "../../../api/Constants";
import Tooltip from "@material-ui/core/Tooltip";
import {ROUTES} from "../../../utils/RouteConstants";
import {useHistory, useLocation} from "react-router-dom";
import {getMemberBalance} from "../../../api/RestCallHelper";
import {BoldUl} from "../../../styles/globalStyles";
import useUserData from "../../../hooks/useUserData";
import {FeedbackReducerActionType, useFeedbackDispatch} from "../../../utils/FeedbackContext";
import {ClickableName} from "../../../styles/globalStyles"

export default ({
    memberDetails
}) => {

    const user = useUserData();
    let dispatch = useFeedbackDispatch();

    let history = useHistory();
    let location = useLocation();

    const [isSending, setIsSending] = useState(false);
    const isMounted = useRef(true);

    const [memberBalance, setMemberBalance] = useState(null);

    const close = (event, reason) => {
        console.log("In Members Screen close callback");
        if (reason === 'clickaway') return;

        dispatch({type: FeedbackReducerActionType.CLOSE_FEEDBACK});
    };

    useEffect(() => {

        // don't send again while we are sending
        if (isSending) return;

        // update state
        setIsSending(true);

        // send the actual request
        getMemberBalance(memberDetails.id, setMemberBalance, dispatch, close, history, location);

        // once the request is sent, update state again
        if (isMounted.current)
            // only update if we are still mounted
            setIsSending(false);

    }, [setMemberBalance, setIsSending]);


    return (
        <DetailsPanelDiv>

            {console.log(memberDetails)}

            <DetailsPanelLeftSection>
                <SectionForDetailPanelLeftHeader>
                    <BoldUl>Entry Date</BoldUl>
                    <BoldUl>ID Number</BoldUl>
                    <BoldUl>Work Number</BoldUl>
                    <BoldUl>Home Number</BoldUl>
                </SectionForDetailPanelLeftHeader>

                <SectionForDetailPanelLeft>
                    <ul>{memberDetails.doe ? formatDate(memberDetails.doe) : " - "}</ul>
                    <ul> {memberDetails.idNumber ? memberDetails.idNumber : " - "}</ul>
                    <ul>{memberDetails.workNumber ? memberDetails.workNumber : " - "}</ul>
                    <ul>{memberDetails.homeNumber ? memberDetails.homeNumber : " - "}</ul>
                </SectionForDetailPanelLeft>
            </DetailsPanelLeftSection>

            <DetailsPanelMiddleSection>
                <SectionForDetailPanelRight>
                    <BoldUl>Address</BoldUl>
                    <ul>{memberDetails.address}</ul>
                    <ul>{memberDetails.area}</ul>
                    <ul>{memberDetails.postalCode}</ul>
                </SectionForDetailPanelRight>

                <SectionForDetailPanelRight>
                    <BoldUl>{memberDetails.dependants.length >0 ? "Dependants" : "No Dependants" }</BoldUl>

                    {memberDetails.dependants.map( x => {
                        return (
                            user != null && user.role.id <= ROLES.ADMIN ?
                                <>
                                    <Tooltip key={x.id} title="Click to Edit Dependant">
                                        <ClickableName>
                                            <ul
                                                onClick = {()=>{
                                                    history.push(ROUTES.DEPENDANTS_FORM, { last : location.pathname , dependant: x, edit: true })
                                                }}
                                            >{x.fullName}</ul>
                                        </ClickableName>
                                    </Tooltip>
                                </>
                                :
                                <ul>{x.id + ". " + x.name + " " + x.surname}</ul>
                        )}
                    )}
                </SectionForDetailPanelRight>
            </DetailsPanelMiddleSection>


            <DetailsPanelRightSection>

                {memberDetails.notes && memberDetails.notes.length > 0 &&
                    <SectionForDetailPanelRight>
                        <BoldUl>{memberDetails.notes.length > 0 && "Notes"}</BoldUl>
                        {memberDetails.notes.map(x=>{
                            return (
                                <ul>
                                    {x.note}
                                </ul>
                            )
                        })
                        }
                    </SectionForDetailPanelRight>
                }
                <SectionForDetailPanelRight>
                    <BoldUl>Balance</BoldUl>

                    <ul>R {memberBalance}</ul>
                </SectionForDetailPanelRight>
            </DetailsPanelRightSection>

        </DetailsPanelDiv>
    );
}